/**
 * The key of a chunk in the booted map, kept apart from the boot so modules that never load anything can name a
 * chunk without bringing the loader in.
 *
 * @param cx Chunk column.
 * @param cy Chunk row.
 * @returns `cx,cy`.
 */
export function chunkKey(cx: number, cy: number): string {
  return `${cx},${cy}`;
}
